export default __webpack_public_path__ + "static/char-v-39-ja-ba15869cedf1a2670788cd8af6a4cd68.mp4";